module.exports = __webpack_public_path__ + "static/media/modern_family.09ac151e.jpg";